// GENERATED FILE - DO NOT MODIFY

export enum CompanyStatusDto {
    Active = "Active",
    Deactivated = "Deactivated",
}